import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../components/common/Button/Button';
import { ROUTES } from '../../constants/routes';
import './NotFound.css';

/**
 * Página 404 - No encontrada
 */
const NotFound = () => {
    return (
        <div className="not-found">
            <div className="container">
                <div className="not-found__content">
                    <h1 className="not-found__title">404</h1>
                    <h2 className="not-found__subtitle">Página no encontrada</h2>
                    <p className="not-found__description">
                        Lo sentimos, la página que buscas no existe o ha sido movida.
                    </p>
                    <Link to={ROUTES.HOME}>
                        <Button variant="primary" size="lg">
                            Volver al Inicio
                        </Button>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default NotFound;
